import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import SchoolWebsite from "../../Assets/Projects/SchoolWebsite.png";
import Registration from "../../Assets/Projects/Registration.png";
import Buildamodern from "../../Assets/Projects/Buildamodern.png";
import dashboard from "../../Assets/Projects/dashboard.png";
import AboutMe from "../../Assets/Projects/AboutMe.png";
import CrashCourseFullStackWebApp from "../../Assets/Projects/CrashCourseFullStackWebApp.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={SchoolWebsite}
              isBlog={false}
              title="School Websites"
              description="A Responsive School Websites which includes their programme."
              ghLink="https://schoolwebsitess.netlify.app/"
              demoLink="https://schoolwebsitess.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Registration}
              isBlog={false}
              title="Registration Form"
              description="A registration form using HTML, CSS, Javascript"
              ghLink="https://registrationformmm.netlify.app/"
              demoLink="https://registrationformmm.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Buildamodern}
              isBlog={false}
              title="Learning Is Fun"
              description="Learning Websites which uses HTML, CSS, Javascript, Bootstrap"
              ghLink="https://learningisfunnn.netlify.app/"
              demoLink="https://learningisfunnn.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dashboard}
              isBlog={false}
              title="Dashboard"
              description="A responsive Dashboard which includes many dark theme toggle"
              ghLink="https://bananadashboard.netlify.app/"
              demoLink="https://bananadashboard.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AboutMe}
              isBlog={false}
              title="About Me"
              description="A simple About Me page just to show the personality of me"
              ghLink="https://aboutanscom.netlify.app/"
              demoLink="https://aboutanscom.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={CrashCourseFullStackWebApp}
              isBlog={false}
              title="What I learned"
              description="Somewhat like a TO-DO List"
              ghLink="https://todayilearnnn.netlify.app/"
              demoLink="https://todayilearnnn.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
